import { Component, OnInit } from '@angular/core';
import { CurrentPageWatcherService } from '../CurrentPageWatcher';
import { Subscription } from 'rxjs';
import { ContentPageModel } from '../../../model/models';

@Component({
  selector: 'app-dynamic-content',
  templateUrl: './dynamic-content.component.html',
  styleUrls: ['./dynamic-content.component.css']
})
export class DynamicContentComponent implements OnInit {

  headerContentSubscription : Subscription;
  headerContent : ContentPageModel = new ContentPageModel;
  lastStep : boolean =false;

  constructor(private currentPageWatcher: CurrentPageWatcherService) { 

    this.lastStep = this.currentPageWatcher.lastStep;

    this.headerContentSubscription = this.currentPageWatcher.getHeaderContent().subscribe(headerContent=>{
      this.headerContent = headerContent;
    })
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/dynamic-content/dynamic-content.component.ts